import { Router } from '@angular/router';
import { AiAgentClientTool } from '../types/client-tool.type';

export interface NavigateToArgs {
  route: string;
  queryParams?: Record<string, string>;
}

/** Opens a page of the application. Absolute routes only — a relative one would
 *  resolve against whatever page happens to be open when the tool runs. */
export const navigateToTool: AiAgentClientTool<NavigateToArgs> = {
  name: 'navigate_to',
  description:
    'Öffnet eine Seite der Anwendung. Die Route muss mit "/" beginnen, z.B. "/sales-statistics/dashboard".',
  parameters: {
    type: 'object',
    properties: {
      route: {
        type: 'string',
        description: 'Absolute Route, beginnend mit "/".',
      },
      queryParams: {
        type: 'object',
        additionalProperties: { type: 'string' },
        description: 'Optionale Query-Parameter.',
      },
    },
    required: ['route'],
  },
  async execute(args, injector) {
    const route = args?.route ?? '';
    if (!route.startsWith('/'))
      return { navigated: false, error: 'route muss mit "/" beginnen' };
    const navigated = await injector
      .get(Router)
      .navigate([route], { queryParams: args.queryParams });
    return { navigated, route };
  },
};
